var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"question"},[_c('el-tooltip',{attrs:{"effect":"dark","placement":_vm.placement}},[_c('div',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.sanitizeHtml(_vm.content))},slot:"content"}),_c('i',{staticClass:"el-icon-question"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }